import FormField from "./FormField";
import OptionsValidator from "./validators/OptionsValidator";

export default class OptionField extends FormField {
    constructor(options, initialValue=undefined) {
        super(initialValue);
        this._validators = [new OptionsValidator(options)];
    }
}
